/**
 * Generic error message from API response (e.g. DRF validation errors).
 * Returns a user-friendly string.
 * Note: api.js interceptor rejects error.response, so err can be either
 * the full axios error (err.response.data) or directly the response (err.data).
 * @param {Error|{ data?: object }} err - Axios error or response object
 * @param {string} defaultMessage - Default message if error cannot be parsed
 * @returns {string}
 */
export function getApiErrorMessage(err, defaultMessage = 'Tapahtui virhe. Yritä uudelleen.') {
  const data = err?.response?.data ?? err?.data;
  if (!data || typeof data !== 'object') return defaultMessage;

  // Yksi yleinen viesti (esim. 403/404)
  if (typeof data.detail === 'string') return data.detail;
  if (typeof data.message === 'string') return data.message;

  // Field-specific errors (e.g. { serial_number: ["message"] })
  const fieldLabels = {
    serial_number: 'Sarjanumero',
    name: 'Nimi',
    model: 'Malli',
    status: 'Tila',
    current_pool: 'Altaan tila',
    company: 'Yritys',
  };
  const parts = [];
  for (const [key, value] of Object.entries(data)) {
    if (Array.isArray(value) && value.length > 0) {
      const label = fieldLabels[key] || key;
      const msg = value[0];
      parts.push(typeof msg === 'string' ? `${label}: ${msg}` : msg);
    } else if (typeof value === 'string') {
      parts.push(value);
    }
  }
  if (parts.length > 0) return parts.join('. ');
  return defaultMessage;
}
